import type { ListaEstudios as Lista } from '@athena/shared';
import { diccionarioDe, type Idioma } from '../../../i18n/index.js';

/**
 * CATALOGO-EN-CONSULTA (Iván, 2026-10-17): la respuesta a «¿qué estudios tenéis?». La pone el motor
 * con la búsqueda por texto del catálogo, así que **todo lo que se lee aquí es texto fijo de la web o
 * sale de la tabla `fuentes`**: el modelo no escribe nada sobre el catálogo.
 *
 * Enlaces con `<a>` y no con `Link`, como `Sugerencias`: se pinta también fuera del enrutador.
 */
export function ListaEstudios({ lista, idioma }: { readonly lista: Lista; readonly idioma: Idioma }) {
  const t = diccionarioDe(idioma).consulta.estudios;
  const palabras = lista.palabras.join(', ');
  const cabecera =
    lista.palabras.length === 0
      ? t.todos.replace('{total}', String(lista.total))
      : lista.coincidencias === 0
        ? t.ninguno.replace('{palabras}', palabras)
        : (lista.coincidencias === 1 ? t.coincideUno : t.coinciden).replace('{n}', String(lista.coincidencias)).replace('{palabras}', palabras);
  const recortada = lista.coincidencias > lista.estudios.length;

  return (
    <section className='mb-[18px]' data-bloque='ListaEstudios'>
      <p className='m-0 mb-3 font-(family-name:--text) text-[16px] leading-[1.6] text-(--ink)'>{cabecera}</p>
      {lista.estudios.length === 0 ? null : (
        <ul className='m-0 mb-3 flex list-none flex-col gap-3 p-0'>
          {lista.estudios.map(e => (
            <li key={e.slug}>
              <a href={`/fuentes/${encodeURIComponent(e.slug)}`} className='font-(family-name:--text) text-[15px] text-(--teal-deep)'>
                {e.titulo}
              </a>
              <span className='block font-(family-name:--text) text-[13px] text-(--ink-soft)'>
                {[e.editor, e.anio === null ? null : String(e.anio)].filter(p => p !== null && p !== '').join(' · ')}
              </span>
            </li>
          ))}
        </ul>
      )}
      {recortada ? (
        <p className='m-0 mb-2 font-(family-name:--text) text-[13px] text-(--ink-faint)'>
          {t.recortada.replace('{n}', String(lista.estudios.length)).replace('{de}', String(lista.coincidencias))}
        </p>
      ) : null}
      <a href='/fuentes' className='font-(family-name:--text) text-[15px] text-(--teal-deep)'>
        {t.verTodos.replace('{total}', String(lista.total))}
      </a>
    </section>
  );
}
